/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatDate } from 'src/utils/dates';
import { usersAPI } from 'src/api/modules/users';
import notice from 'src/common/components/Notice';
import AntTabs from 'src/common/components/AntTabs';
import { createR } from 'src/utils/UniqueIdGenerator';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import { usePagination } from 'src/hooks/usePagination';
import {
	access_columns,
	logSegurityColumns,
	defaultFilter,
	defaultFilter2,
	filterForm1,
	filterForm2,
	recordTypeTabs,
} from './utils/list_data';

const RecordsList = () => {
	const [tabValue, setTabValue] = useState(1);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [filter, setFilter] = useState(defaultFilter);
	const [filter2, setFilter2] = useState(defaultFilter2);
	const [miembros, setMiembros] = useState([]);
	const [logUser, setLogUser] = useState([]);
	const [users, setUsers] = useState([]);
	const {
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
		handlePagination,
	} = usePagination();

	const handleChangeFilter = ({ target }, pagination = false) => {
		const { name, value } = target;
		setFilter({ ...filter, [name]: value });
	};

	const handleChangeFilter2 = ({ target }) => {
		const { name, value } = target;
		setFilter2({ ...filter2, [name]: value });
	};

	useEffect(() => {
		getUsers();
		if (systemLevelRole === 'OPERADOR DE SEGURIDAD') setTabValue(2);
	}, [systemLevelRole]);

	const getUsers = () => {
		usersAPI
			.getAllUsersStatus()
			.then((response) => {
				if (response && response.length > 0) {
					let usersFlag = [];
					response.forEach((item) => {
						usersFlag.push({
							value: item.id,
							text: ` ${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
							IN: item.usuario,
						});
					});
					setUsers([...(usersFlag || [])]);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};
	const onConfirmFilter = () => {
		let promise = null;

		switch (tabValue) {
			case 1:
				if (!filter.user && !filter.nick) {
					return notice('Debe seleccionar un usuario', 'danger');
				}

				if (!filter.status) {
					return notice('Debe seleccionar un estatus', 'danger');
				}
				if (
					(!filter.start_date && filter.end_date) ||
					(filter.start_date && !filter.end_date)
				) {
					return notice(
						'Si proporciona una fecha de inicio o una fecha de fin, ambas deben estar presentes',
						'warning'
					);
				}
				if (
					filter.start_date &&
					filter.end_date &&
					filter.start_date > filter.end_date
				) {
					return notice(
						'La fecha de inicio no puede ser mayor que la fecha de fin',
						'warning'
					);
				}

				notice('Filtrado en proceso', 'info');
				promise = usersAPI.getFilterAccessLog({
					...filter,
					user: filter.user.value,
					pagination,
					currentPage,
				});
				break;
			case 2:
				if (!filter2.user2 && !filter2.nick2)
					return notice('Debe seleccionar un usuario', 'danger');

				if (!filter2.status2)
					return notice('Debe seleccionar un estatus', 'danger');
				if (
					(!filter2.start_date2 && filter2.end_date2) ||
					(filter2.start_date2 && !filter2.end_date2)
				) {
					return notice(
						'Si proporciona una fecha de inicio o una fecha de fin, ambas deben estar presentes',
						'warning'
					);
				}
				if (
					filter2.start_date2 &&
					filter2.end_date2 &&
					filter2.start_date2 > filter2.end_date2
				) {
					return notice(
						'La fecha de inicio no puede ser mayor que la fecha de fin',
						'warning'
					);
				}
				notice('Filtrado en proceso', 'info');

				promise = usersAPI.getFilterAccessLogSegurity({
					user: filter2.user2.value,
					status: filter2.status2,
					start_date: filter2.start_date2,
					end_date: filter2.end_date2,
					inUsuarioAfectado: filter2.user2.IN,
					usuario: filter2.nick2,
					pagination,
					currentPage,
				});
				break;
			default:
				break;
		}
		promise
			.then((response) => {
				setMiembros([]);
				setLogUser([]);
				if (response.accesos && response.accesos.length > 0) {
					setTotalResults(response.totalRegistros);
					let newResponse = [];
					response.accesos.forEach((item) => {
						//We assigned a unique ID instance (just for the table) for each item with length 16 (could be less)
						newResponse.push({
							...item,
							idUnique: createR(16),
							FullLinkName:
								item.nombre +
								' ' +
								item.apellidoPaterno +
								' ' +
								item.apellidoMaterno,
						});
					});

					if (tabValue === 1) setMiembros(newResponse);
					if (tabValue === 2) setLogUser(newResponse);
				} else {
					notice('No se encontraron resultados', 'warning');
					setTotalResults(0);
				}
			})
			.catch((e) => notice('Error al cargar los acessos'));
	};

	const onClear = () => {
		if (tabValue === 1) {
			setFilter(defaultFilter);
			setMiembros([]);
		}
		if (tabValue === 2) {
			setFilter2(defaultFilter2);
			setLogUser([]);
		}
		setTotalResults(0);
	};

	const handleChangeTab = (newValue) => {
		setTabValue(newValue);
	};
	useEffect(() => {
		if (filter.user || filter.nick || filter2.user2 || filter2.nick2) {
			onConfirmFilter();
		}
	}, [pagination, currentPage]);
	return (
		<>
			{systemLevelRole === 'ADMINISTRADOR GENERAL' && (
				<AntTabs
					value={tabValue}
					options={recordTypeTabs}
					onChange={handleChangeTab}
				/>
			)}
			<PageLayout>
				<FullTable
					title="Bitácora de Accesos"
					items={tabValue === 1 ? miembros : logUser}
					keyField={'idUnique'}
					columns={tabValue === 1 ? access_columns : logSegurityColumns}
					filtersWidth={210}
					filter={tabValue === 1 ? filter : filter2}
					filterForm={
						tabValue === 1
							? filterForm1(onConfirmFilter, onClear, users)
							: filterForm2(onConfirmFilter, onClear, users)
					}
					onFilterChange={
						tabValue === 1 ? handleChangeFilter : handleChangeFilter2
					}
					ExcelFileName={`Bitácora_de_Accesos_${formatDate('P p')}.xls`}
					showPagination
					handlePagination={handlePagination}
					sizePerPageTable={pagination}
					totalPages={totalResults}
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
				/>
			</PageLayout>
		</>
	);
};

export default RecordsList;
